export default __webpack_public_path__ + "static/media/missb7.17880042.jpg";